<template>
  <Container type="card-full">
    <vggrid ref="xGrid" :list="list" tableheight="700" flexname=""
            :cols="cols" :showfooter="false" :showPage="true" :resizable="true" :total="query.total"
            :needBlackRow="false" :needPopMenu="true" :canbeEdit="true"
            @cellClick="cellClick" @pagechange="pagechange"
            :editRules="editRules"
    >
            <template slot="btn">
              <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
          </template>
    </vggrid>

  </Container>
</template>
<script>
  import XEUtils from 'xe-utils'
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  const SUCCESS = 1
  export default {
    name: 'dptarea',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        dptareaList:[],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'dptareaname', fieldtype: 'C', title: '地区名称',calculExpr:'',editRender: { name: 'input'}},
          { field: 'dptareacode', fieldtype: 'C', title: '地区编号',calculExpr:'',editRender: { name: 'input'}},
          { field: 'dptareasort', fieldtype: 'C', title: '排序',calculExpr:'',editRender: { name: 'input'}},
          { field: 'dptareause', fieldtype: 'C', title: '是否使用',syscode: 'dptareause',
           calculExpr:'',editRender: { name: 'select', options: []}},
        ],
        editRules: {
          'dptareaname': [
            {required: true, message: '输入内容不能为空'},
            {max: 40, message: '最多输入40个字符'},
            {validator: ({ cellValue, rule, rules, row, rowIndex, column, columnIndex }) => {
              return new Promise((resolve, reject)=> {
                request({
                    url: '/validate/validateData',
                    method: "post",
                    data: {tablename: 'dptarearec',checkfield: 'dptareaname', checkval: cellValue, id: row.dptareaid, fieldid: 'dptareaid', fieldkey1: 'dptareacosid', fieldkeyval1: this.$store.getters.loginUser.cosid}
                  }).then (res => {
                    res === SUCCESS ? reject(Error(`地区名称不能重复`)) : resolve()
                  })
              })
            }, trigger: 'blur'}
          ]
        },
        dptarea: {},
        query: {
          cosid: this.$store.getters.loginUser.cosid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('SAV', () => this.addOrEdit())
      this.$on('DEL', () => this.delDpt())
      this.$on('CLOSE', () => this.close())
      this.getPageList()
    },
    activated() {
      this.getPageList()
    },
    mounted () {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async authDptForm () {
        if (!this.dptarea.dptid) {
          this.$message.warning('请选择一行!')
          return
        }
        this.$router.push({name: 'dptAuthForm', params: {form: this.dptarea}})
      },
      async delDpt () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xtgl/dptarea/delDptarea',
            method: "post",
            data: this.dptarea
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error('删除失败！')
          }
        })
      },
      async cellClick (row) {
        this.dptarea = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async addOrEdit () {
        if (!await this.$refs.xGrid.validError()) return 
        let model = this.$refs.xGrid.$refs.xGrid.getRecordset()
        model.cosid = this.$store.getters.loginUser.cosid
        let data = await request({
          url: '/xtgl/dptarea/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          await this.getPageList()
          this.$message.success('保存成功！')
        } else {
          this.$message.error('保存失败!')
        }
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/dptarea/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
